import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';
import { morph } from '@theme/morph';

class ProductLosAngeles extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateCurrentShipsIn);
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateTwoViewMediaGallery);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateCurrentShipsIn);
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateTwoViewMediaGallery);
  }

  updatePrice = (event) => {
    const currentPrice = document.querySelector('.price-container');
    
    const newDocument = event.detail.data.html;
    const newPrice = newDocument.querySelector('.price-container');

    if (currentPrice && newPrice) {
      document.startViewTransition(() => {
        morph(currentPrice, newPrice);
      });
    }
  }

  updateCurrentShipsIn = (event) => {
    const currentShipsIn = document.querySelector('.in-stock-container .in-stock-value');
    
    const newDocument = event.detail.data.html;
    const newShipsIn = newDocument.querySelector('.in-stock-container .in-stock-value');

    if (currentShipsIn && newShipsIn) {
      morph(currentShipsIn, newShipsIn);
    }
  }

  updateTwoViewMediaGallery = (event) => {
    const currentTwoViewMediaGallery = document.querySelector('two-view-media-gallery');
    
    const newDocument = event.detail.data.html;
    const newTwoViewMediaGallery = newDocument.querySelector('two-view-media-gallery');

    if (currentTwoViewMediaGallery && newTwoViewMediaGallery) {
      document.startViewTransition(() => {
        morph(currentTwoViewMediaGallery, newTwoViewMediaGallery);
      });
    }
  }
}

if (!customElements.get('product-los-angeles')) {
  customElements.define('product-los-angeles', ProductLosAngeles);
}